import React from 'react';
import { Incident } from '../../pages/law/incidentsData';
import { IncidentCard } from './IncidentCard';

type IncidentListProps = {
  incidents: Incident[];
  onSelectIncident: (incident: Incident) => void;
};

export function IncidentList({ incidents, onSelectIncident }: IncidentListProps) {
  return (
    <div className="incident-list">
      {incidents.map((incident) => (
        <IncidentCard incident={incident} key={incident.id} onSelect={onSelectIncident} />
      ))}
    </div>
  );
}
